module.exports = __webpack_public_path__ + "static/media/Illustration1.7763fd07.svg";